(() => {
  if (window.aldenoHeuristicReady) return;
  window.aldenoHeuristicReady = true;
  const body = document.body;
  const multiBuy = body.matches('.template-index') && document.querySelector('.multi-buy-mb-home')?.closest('.parallax-scroll__panel');
  if (multiBuy) {
    multiBuy.classList.add('aldeno-home-multibuy');
    const heading = multiBuy.querySelector('.parallax-scroll__widget-heading');
    if (heading?.textContent.trim() === 'Aldeno Multi-buy Program') {
      const lineBreak = document.createElement('br');
      lineBreak.className = 'aldeno-mobile-break';
      heading.replaceChildren('Aldeno ', lineBreak, 'Multi-buy Program');
    }
  }
  const hero = document.querySelector('#MainContent > .shopify-section');
  const backTop = document.querySelector('#footerBackToTop, [data-aldeno-back-top]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scheduled = false;
  let mobileHeaderActivated = false;
  const update = () => {
    scheduled = false;
    // Home's first section contains several panels, so its full height is not a hero threshold.
    const threshold = window.matchMedia('(max-width:1024px)').matches ? 70 : body.matches('.template-index,.template-collection,.template-product,.template-cart,.template-search,[data-aldeno-template="club-aldeno"],[data-aldeno-template="il-primo"]') ? 70 : Math.max(70, (hero?.offsetHeight || 300) - 90);
    const mobileHeader = window.matchMedia('(max-width: 1024px)').matches;
    if (!mobileHeader || window.scrollY <= 1) mobileHeaderActivated = false;
    else if (window.scrollY > threshold) mobileHeaderActivated = true;
    // Retain the floating bar on upward scroll, then restore the original header at the very top.
    body.classList.toggle('aldeno-header-scrolled', window.scrollY > threshold || (mobileHeader && mobileHeaderActivated));
    if (body.classList.contains('template-product')) {
      const sentinel = document.querySelector('.t4s-pr-atc-card__sentinel');
      const card = sentinel?.nextElementSibling;
      if (card?.classList.contains('t4s-pr-atc-card')) {
        const fixed = window.innerWidth <= 767 && sentinel.getBoundingClientRect().top < 0;
        card.classList.toggle('is-fixed', fixed);
        body.classList.toggle('aldeno-pdp-atc-fixed', fixed);
        const preview = document.getElementById('PBarNextFrame');
        const previewRect = preview?.getBoundingClientRect();
        const previewHeight = previewRect && previewRect.top < window.innerHeight ? Math.min(60, Math.max(0, window.innerHeight - previewRect.top)) : 0;
        body.style.setProperty('--aldeno-preview-height', `${previewHeight}px`);
        body.style.setProperty('--aldeno-atc-height', `${card.offsetHeight}px`);
        // Keep the currency app clear of both the in-flow and fixed purchase bar.
        const cardRect = card.getBoundingClientRect();
        const purchaseVisible = cardRect.top < window.innerHeight && cardRect.bottom > 0;
        const currencyBottom = purchaseVisible
          ? Math.max(previewHeight + 30, window.innerHeight - cardRect.top + 12)
          : previewHeight + 30;
        body.style.setProperty('--aldeno-pdp-currency-bottom', `${currencyBottom}px`);
      }
    }
    if (backTop) {
      body.classList.toggle('aldeno-footer-in-view', backTop.getBoundingClientRect().top < window.innerHeight);
    }
  };
  window.addEventListener('scroll', () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('pageshow', update);
  backTop?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    document.querySelector('#MainContent')?.focus({ preventScroll: true });
  });
  update();
})();
